export const getCookieConsent = (): string | null => {
    try {
        return localStorage.getItem('cookieConsent');
    } catch {
        return null;
    }
};

export const setCookieConsent = (value: string): void => {
    try {
        localStorage.setItem('cookieConsent', value);
    } catch {
        // localStorage not available, consent won't persist
    }
};
